"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[91794],{

/***/ 91794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _LoaderRemote__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71593);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _context_TranslationContext_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73040);





var Fancybox = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 99965).then(__webpack_require__.bind(__webpack_require__, 92235));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(92235)
            ];
        }
    }
});
var Content = function(param) {
    var styles = param.styles, Images = param.Images, page = param.page;
    var morePhotos = (0,_context_TranslationContext_js__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .m)().morePhotos;
    var CoverPhotos = Images.slice(0, 4), PhotosWithoutCover = Images.slice(4, Images.length);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: styles.Photos,
                children: CoverPhotos.map(function(item, key) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Fancybox, {
                        options: {
                            infinite: false
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "w-full h-full relative",
                            "data-fancybox": "gallery",
                            "data-src": "https://cdn.balayivillasikirala.com.tr" + "/uploads/" + item.Filename,
                            "data-thumb": "https://cdn.balayivillasikirala.com.tr" + "/uploads/150/" + item.Filename,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    className: "cursor-pointer",
                                    src: item.Filename,
                                    objectFit: "cover",
                                    objectPosition: "center",
                                    layout: "fill",
                                    alt: item.aciklama,
                                    sizes: key == 0 ? "\n                (max-width: 1024px) 30vw,\n                60vw" : "\n                    (max-width: 1024px) 15vw,\n                    30vw",
                                    loader: _LoaderRemote__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z,
                                    priority: key == 0 ? 1 : 0
                                }),
                                key == CoverPhotos.length - 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "hidden lg:flex justify-center items-center absolute inset-0 bg-black bg-opacity-50 pointer-events-none",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        className: "font-semibold text-xl text-white",
                                        children: [
                                            "+",
                                            Images.length - CoverPhotos.length,
                                            " ",
                                            morePhotos
                                        ]
                                    })
                                })
                            ]
                        })
                    }, item.uploadID);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "hidden",
                children: PhotosWithoutCover.map(function(i, k) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        "data-fancybox": "gallery",
                        "data-src": "https://cdn.balayivillasikirala.com.tr" + "/uploads/" + i.Filename,
                        "data-thumb": "https://cdn.balayivillasikirala.com.tr" + "/uploads/150/" + i.Filename
                    }, k);
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Content);


/***/ })

}]);